import { ISiteLoginContent } from "../models/site-login-content";
import { authApi } from "./auth.service";

const BASIC_URL = process.env.REACT_APP_APP;

export const getAllSiteLoginContents = () => {
  return authApi.get<ISiteLoginContent[]>(BASIC_URL + "/api/v1/SiteLoginContent");
};
